<script setup>
import { computed, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";

import SidenavItem from "./SidenavItem.vue";
import { HIDDEN_GAME_CODES } from "@/constants/hiddenGames";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();
const currentRoute = computed(() => route.path.split("/")[1]?.toLowerCase());

// เมนูหลัก (คงที่)
const baseMenu = [
  {
    to: "/dashboard-default",
    key: "dashboard-default",
    label: "Dashboard",
    icon: "ni-tv-2 text-primary",
  },
  {
    to: "/realtime",
    key: "realtime",
    label: "Realtime",
    icon: "ni-watch-time text-success",
  },
  {
    to: "/trends",
    key: "trends",
    label: "Trends",
    icon: "ni-collection text-info",
  },
  {
    to: "/gamelist",
    key: "gamelist",
    label: "ปรับอัตรา RTP",
    icon: "ni-collection text-info",
  },
  {
    to: "/gameactive",
    key: "gameactive",
    label: "Game Active",
    icon: "ni-collection text-info",
  },
  {
    to: "/user",
    key: "user",
    label: "ผู้ใช้งาน",
    icon: "ni-single-02 text-dark",
  },
  {
    to: "/limit-reward",
    key: "limit-reward",
    label: "Limit Reward",
    icon: "ni-scissors text-dark",
  },
  {
    to: "/bet-range",
    key: "bet-range",
    label: "ระดับการเดิมพัน",
    icon: "ni-chart-bar-32 text-info",
  },
  

  // หัวข้อ: รายละเอียดเกมส์
  { divider: true, label: "รายละเอียดเกมส์" },
];

// รายชื่อเกม — ดึงจาก API gameconfig (แหล่งเดียว) เพิ่มเกมใน DB แล้วขึ้นเองอัตโนมัติ
// ทุกเกมใช้ route generic เดียว /game/:schema → ไม่ต้องแก้ router/sidebar อีก
const gameList = ref([]);

onMounted(async () => {
  try {
    const res = await axios.post(
      "https://dashboard-api.linkstudio.io/api/v1/game/control/gameconfig",
      {}
    );
    gameList.value = (res.data?.data?.list ?? [])
      .filter((g) => g.schema_name && !HIDDEN_GAME_CODES.includes(g.code))
      .sort((a, b) =>
        String(a.code).localeCompare(String(b.code), undefined, {
          numeric: true,
        })
      );
  } catch (err) {
    console.error("โหลด gameconfig ไม่สำเร็จ", err);
  }
});

const gameMenu = computed(() =>
  gameList.value.map((g) => ({
    to: {
      path: `/game/${g.schema_name}`,
      query: { name: g.name, code: g.code },
    },
    schema: g.schema_name,
    label: `${g.code} ${g.name}`,
    icon: "ni-spaceship text-info",
  }))
);

const menuItems = computed(() => [...baseMenu, ...gameMenu.value]);

// ไฮไลต์เมนูที่ active — เกมเทียบด้วย schema, เมนูหลักเทียบด้วย key
function isActive(item) {
  if (item.schema) {
    return (
      route.path.startsWith("/game/") && route.params.schema === item.schema
    );
  }
  return currentRoute.value === item.key;
}
</script>

<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li v-for="(item, index) in menuItems" :key="index" class="nav-item">
        <template v-if="item.divider">
          <h6
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
            :class="isRTL ? 'me-4' : 'ms-2'"
          >
            {{ item.label }}
          </h6>
        </template>
        <template v-else>
          <sidenav-item
            :to="item.to"
            :class="isActive(item) ? 'active' : ''"
            :navText="item.label"
          >
            <template #icon>
              <i :class="`ni ${item.icon} text-sm opacity-10`"></i>
            </template>
          </sidenav-item>
        </template>
      </li>
    </ul>
  </div>
</template>
